import dashboard from './dashboard'
// import behaviour from './behaviour'
// import visitors from './visitors'
import shortcodes from './shortcodes'
import measurables from './measurables'
import acquisition from './acquisition'
import tools from './tools'

// Array of sections
export default [...dashboard, ...shortcodes, ...measurables, ...acquisition, ...tools/*, ...visitors, ...behaviour*/]
